const kgcmbcSetTitle = (title, page) => {
  console.log('执行了-----kgcmbcSetTitle', page);
  const indexPages = ['/home', '/search'];
  const isIndex = indexPages.includes(page);
  let bankTitle = title;
  let jsonParam = {};
  if (!isIndex) {
    // 不是首页需要重置标题和左上角返回
    jsonParam = JSON.parse(initTitleBar(bankTitle));
    console.log('不是首页');
  } else {
    // 首页不要处理左上角返回
    const jsonTitle = '{"title":"' + bankTitle + '","leftButton":{"exist":"false","name":"返回"}}';
    jsonParam = JSON.parse(jsonTitle);
    console.log('是首页');
  }
  console.log('民生jsonParam----------', jsonParam);
  try {
    const _setTitleBar = setTitleBar || window.setTitleBar;
    _setTitleBar(jsonParam);
  } catch (error) {
    console.log('全局印用民生银行error', error);
  }
};

const goBack = function () {
  console.log('执行了goBack-----------', window.location.href);
  console.log(window.browser, 'window.browser');
  if (window.browser && window.browser.versions.ios) {
    console.log('执行了goBack-----------IOS', window.location.href);
    window.history.go(-1);
  } else {
    return () => {
      window.history.go(-1);
    };
  }
};

window.goBack = goBack;
//初始化抬头
function initTitleBar(bankTitle) {
  return (
    '{"title":"' + bankTitle + '","leftButton":{"exist":"true","name":"返回","func":"goBack()"}}'
  );
}
export default kgcmbcSetTitle;
